<template>
  <div class="app-booked-options-table">
    <div class="summary-data-costs">
      <b-row class="data-line thead">
        <b-col md="" sm="" class="data-cell first">
          <slot name="txtOptionsHeader">Ausgewählte Optionen</slot>
        </b-col>
        <b-col v-if="isSuccessTable" md="" sm="" class="data-cell second">
          <slot name="txtCosts">Monatliche Kosten</slot>
        </b-col>
        <b-col v-if="isSuccessTable" md="" sm="" class="data-cell third">
          <slot name="txtDuration">Laufzeit</slot>
        </b-col>
        <b-col  v-if="!isSuccessTable" md="" sm="" class="data-cell error">
          <slot name="txtError">Status</slot>
        </b-col>
      </b-row>
    </div>

    <div class="data-block-options" v-for="item in options" :key="item.id">
      <b-row class="data-line opts">
        <b-col md="" sm="" class="data-cell first name">
          <span v-html="item.name"></span>
          <span v-if="item.extraHtml" v-html="item.extraHtml"></span>
          <div class="option-info">
            <p v-if="item.desc" v-html="item.desc">
            </p>
          </div>
        </b-col>
        <b-col v-if="isSuccessTable" md="" sm="" class="data-cell second price">
          <span v-if="item.price !== 0">{{ centsToEuros(item.price) }}</span>
          <span v-if="item.price === 0">
            <slot name="txtForFree">kostenlos</slot>
          </span>
        </b-col>
        <b-col v-if="isSuccessTable && isDeactivate === false" md="" sm="" class="data-cell third duration">
          <span v-if="item.duration">{{ item.duration.amount }} {{ durationUnit(item.duration.unit) }}</span>
          <span v-else><slot name="txtNoDuration">Gültig bis: unbefristet</slot></span>
        </b-col>
        <b-col v-if="isSuccessTable && isDeactivate === true" md="" sm="" class="data-cell third end-of-runtime">
          <span v-if="item.endOfRuntime">{{ toDate(item.endOfRuntime) }}</span>
          <span v-else><slot name="txtNoEndRuntime">innerhalb einer Stunde</slot></span>
        </b-col>
        <b-col v-if="showErrorMsg(item)" md="" sm="" class="data-cell error">
          <span>{{ item.message }}</span>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import price from '@/mixins/price'
import durationUnit from '@/mixins/durationUnit'

export default {
  name: 'OptionsTable',
  props: {
    options: {
      type: Array,
      default: () => []
    },
    successTable: {
      type: Boolean,
      default: false
    },
    isDeactivate: {
      type: Boolean,
      default: false
    }
  },
  mixins: [
    price,
    durationUnit
  ],
  computed: {
    isSuccessTable () {
      return this.successTable
    }
  },
  methods: {
    showErrorMsg (item) {
      return !this.isSuccessTable && item.message
    },
    centsToEuros (value) {
      return this.$config.calendar.formatter.currencyFormatter.format(parseInt(value) / 100)
    },
    toDate (date) {
      return this.$config.calendar.formatter.dateFormatter.format(new Date(date))
    }
  }
}
</script>
